import { Box, Link, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

type LoyaltyPerformanceHeaderProps = {
  open: () => void;
};

const LoyaltyPerformanceHeader = ({ open }: LoyaltyPerformanceHeaderProps) => {
  const { t } = useTranslation();

  return (
    <Stack m={2}>
      <Box display="flex" justifyContent="flex-end" whiteSpace="pre">
        {t('page.loyaltyPerformanceReport.learnMoreText.learnMore')}
        {'  '}
        <Link
          component="button"
          variant="body2"
          onClick={() => {
            open();
          }}
        >
          {t('page.loyaltyPerformanceReport.learnMoreText.link')}
        </Link>
      </Box>
    </Stack>
  );
};

export default LoyaltyPerformanceHeader;
